// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"a72bd00a","850":"d689ab3d","889":"d4315f12"}[chunkId] + ".chunk.css";
};